import React, { useEffect, useState } from "react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { BsArrowRightCircle } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { FaGithub } from "react-icons/fa";

const ProjectDetails = () => {
  const { id } = useParams(); // Get the ID parameter from the URL
  const [project, setProject] = useState(null);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const response = await fetch("/db.json"); // Adjust the path to your JSON file
        if (!response.ok) {
          throw new Error("Failed to fetch project details");
        }
        const data = await response.json();
        const foundProject = data.find((proj) => proj.id === parseInt(id));
        setProject(foundProject);
      } catch (error) {
        console.error("Error fetching project details:", error);
      }
    };

    fetchProjectDetails();
  }, [id]); // Re-run the effect when the ID parameter changes

  if (!project) {
    return <div>Loading...</div>;
  }

  const {
    title,
    description,
    liveSite,
    clientRepo,
    serverRepo,
    images,
    details,
  } = project;

  const { overview, technologies } = details;

  console.log(images);

  return (
    <div className="min-h-[863px] lg:px-[200px]">
      <h2 className="text-3xl font-bold text-center pt-10 text-gray-300">
        {title}
      </h2>
      <p className="text-lg text-center pt-4">{description}</p>
      <div className="mt-3 flex justify-center gap-3">
        <a
          href={liveSite}
          rel="noreferrer"
          className="btn btn-primary"
          target="_blank"
        >
          Live-Site
        </a>
        {serverRepo === "" ? (
          <a
            href={clientRepo}
            rel="noreferrer"
            className="btn btn-accent"
            target="_blank"
          >
            Github<FaGithub className="ml-1"></FaGithub>
          </a>
        ) : (
          <>
            <a
              href={clientRepo}
              rel="noreferrer"
              className="btn btn-accent"
              target="_blank"
            >
              Client<FaGithub className="ml-1"></FaGithub>
            </a>
            <a
              href={serverRepo}
              rel="noreferrer"
              className="btn btn-success"
              target="_blank"
            >
              Server<FaGithub className="ml-1"></FaGithub>
            </a>
          </>
        )}
      </div>
      <p className="text-2xl text-center pt-8 pb-6 font-bold text-gray-300">
        Snapshots
      </p>
      <div className="flex justify-center">
        <Swiper
          className="h-[498px]"
          // install Swiper modules
          modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={20}
          slidesPerView={2}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={() => console.log("slide change")}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                className="h-[500px] object-cover w-full"
                src={image}
                alt=""
              />
            </SwiperSlide>
          ))}
          ...
        </Swiper>
      </div>
      <p className="mt-10 text-2xl font-semibold text-center">
        Used Technologies
      </p>
      <p className="mt-4 text-lg font-semibold flex flex-wrap justify-center  gap-3 lg:gap-0">
        {technologies.map((tech, index) => (
          <span
            key={index}
            className="bg-gray-700 p-2 rounded-lg text-base mr-3"
          >
            {tech}
          </span>
        ))}
      </p>
      <p className="mt-12 text-2xl font-semibold text-center">Features </p>
      <div className="mt-6 mb-8 px-6">
        {" "}
        {overview.map((eachoverview, index) => (
          <p key={index} className="pb-3">
            <BsArrowRightCircle className="inline"></BsArrowRightCircle>{" "}
            <span>{eachoverview}</span>
          </p>
        ))}
      </div>
    </div>
  );
};

export default ProjectDetails;
